import { ErrorBoundary } from '@sentry/react';
import React, { ReactNode } from 'react';

interface CustomErrorBoundaryProps {
  children: ReactNode;
}

const CustomErrorBoundary = ({ children }: CustomErrorBoundaryProps) => {
  return (
    <ErrorBoundary fallback={<p>Something went wrong</p>}>
      {children}
    </ErrorBoundary>
  );
};

export default CustomErrorBoundary;
